
import React from 'react';
import { UserPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CustomerEmptyProps {
  onCreateNew: () => void;
}

const CustomerEmpty = ({ onCreateNew }: CustomerEmptyProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="bg-gray-100 rounded-full p-3 mb-4">
        <UserPlus className="h-6 w-6 text-gray-500" />
      </div>
      <h3 className="font-medium mb-2">Aucun client disponible</h3>
      <p className="text-sm text-muted-foreground mb-6">
        Vous n'avez pas encore de client dans votre liste
      </p>
      <Button 
        onClick={onCreateNew}
        variant="outline"
        className="reference-table-add-button"
      >
        <UserPlus className="h-4 w-4 mr-2" />
        <span>Créer un nouveau client</span>
      </Button>
    </div>
  );
};

export default CustomerEmpty;
